module.exports = __webpack_public_path__ + "img/houmon.9c5cd91e.png";